import { combineReducers } from 'redux'

// reducers
import shared from './shared/reducer'
import user from './user/reducer'
import products from './products/reducer'
import locations from './locations/reducer'
import advantages from './advantages/reducer'
import campaigns from './campaigns/reducer'

export const rootReducer = combineReducers({
  shared,
  user,
  products,
  locations,
  advantages,
  campaigns,
})



// WEBPACK FOOTER //
// ./src/store/index.js